import type { Form } from '@cognitoforms/types/server-types/forms/configuration/form';
import type { Field } from '@cognitoforms/types/server-types/model/field';
import type { TypeMeta } from '@cognitoforms/types/server-types/model/type-meta';
import type { TypedExoWebEntity } from 'src/views/admin/utils/exoweb';

export type LegacyForm = TypedExoWebEntity<Form & { HasChanges: boolean }>;

export type LegacyTypeMeta = TypedExoWebEntity<TypeMeta>;

export type LegacyField = TypedExoWebEntity<Field>;

const fieldAt = (typeMeta: LegacyTypeMeta | null, index: number): LegacyField | null =>
	typeMeta ? typeMeta.get_Fields().find(field => field.get_Index() === index) ?? null : null;

export const findLegacyField = (legacyForm: LegacyForm, parentFieldSetId: string, index: number): LegacyField | null => {
	let typeMeta: LegacyTypeMeta | null = legacyForm;

	for (const containerIndex of parentFieldSetId.split('.').slice(1)) {
		const container = fieldAt(typeMeta, Number(containerIndex));
		if (!container)
			return null;
		typeMeta = container.get_ChildType();
	}

	return fieldAt(typeMeta, index);
};
